import api from "api";
import { getDurationIcon, getDurationTipText, getInstructionsIconName } from "./exerciseHelpers";
import { clearExerciseHistories } from "../rjsf/GeneratorPicker/historyDB";

const supportApiBase = process.env.REACT_APP_API_URL_V2 + "/v2/support/";

const createLevelPayload = (level: any, index: number) => {
  const { translations, movement, position, ...restLevel } = level;

  const _movement = movement === "none" ? undefined : movement;
  const _position = position === "none" ? undefined : position;

  return {
    ...restLevel,
    level: index + 1,
    duration_icon: getDurationIcon(level.duration_unit),
    movement: _movement,
    position: _position,
  };
};

const createTranslationPayload = (translation: any, level: any) => {
  const { video } = translation || {};
  const { video_file_url, video_thumbnail_file_url } = video || {};

  const language = translation.locale.split("-")[0];

  return {
    ...translation,
    video_file_url,
    video_thumbnail_file_url,
    video_url: "", // legacy
    instructions_icon_name: getInstructionsIconName(level.duration_unit),
    instructions_text2: getDurationTipText(level.duration_unit, language),
  };
};

export const submitNewExercise = async (data: any) => {
  console.log("full data submitted: ", data);
  const { levels, ...exercise } = data;

  console.log("Submitting exercise data:", exercise, levels);
  // @ts-ignore

  const exerciseResponse = await api("POST /exercise", {
    root: supportApiBase,
    data: exercise,
  });

  // @ts-ignore
  const exerciseResponseJson = await exerciseResponse.json();
  const exerciseId = exerciseResponseJson.id;
  console.log("Exercise created with ID:", exerciseId);

  if (!exerciseResponseJson.id) {
    console.error("Failed to create exercise");
    return;
  }

  for (const [index, level] of levels.entries()) {
    console.log("Creating level with data:", level);
    const { translations, ...restLevel } = level;
    const levelPayload = createLevelPayload(restLevel, index);
    // @ts-ignore
    const levelResponse = await api(`POST /exercises/${exerciseId}/level`, {
      root: supportApiBase,
      data: levelPayload,
    });

    const levelResponseJson = await levelResponse.json();
    const levelId = levelResponseJson.id;
    console.log("level created with ID:", levelId);

    for (const [, translation] of translations.entries()) {
      console.log("Creating translations with data:", translation);
      const translationPayload = createTranslationPayload(translation, level);

      const translationResponse = await api(
        // @ts-ignore
        `POST /exercises/${exerciseId}/levels/${levelId}/translation`,
        {
          root: supportApiBase,
          data: translationPayload,
        }
      );
      const translationResponseJson = await translationResponse.json();
      const translationId = translationResponseJson.id;
      console.log("Translation created with ID:", translationId);
    }
  }

  // Clear IndexedDB chat histories for this exercise
  await clearExerciseHistories(exerciseId);

  return exerciseId;
};

export const submitUpdateExercise = async (data: any, initialData: any) => {
  const { levels, ...exercise } = data;

  console.log("Submitting exercise data:", exercise);
  // @ts-ignore
  await api(`PUT /exercises/${exercise.id}`, {
    root: supportApiBase,
    data: exercise,
  });

  for (const [index, level] of levels.entries()) {
    const existingLevel = initialData.levels.find((lvl: any) => lvl.id === level.id);
    const { translations, ...levelNoTranslation } = level;
    const levelPayload = createLevelPayload(levelNoTranslation, index);

    if (existingLevel) {
      console.log("Update level for exercise ID:", exercise.id, "with data:", level);
      // @ts-ignore
      await api(`PUT /exercises/${exercise.id}/levels/${level.id}`, {
        root: supportApiBase,
        data: levelPayload,
      });
    }
    if (!existingLevel) {
      console.log("Update level for exercise ID:", exercise.id, "with data:", level);
      // @ts-ignore
      const levelResponse = await api(`POST /exercises/${exercise.id}/level`, {
        root: supportApiBase,
        data: levelPayload,
      });
      const levelResponseJson = await levelResponse.json();
      const levelId = levelResponseJson.id;
      console.log("level created with ID:", levelId);
      level.id = levelId; // Update the level object with the new ID
    }

    for (const [, translation] of translations.entries()) {
      const existingTranslation =
        existingLevel && existingLevel.translations.find((trans: any) => trans.id === translation.id);
      const translationPayload = createTranslationPayload(translation, level);

      if (existingTranslation) {
        await api(
          // @ts-ignore
          `PUT /exercises/${exercise.id}/levels/${level.id}/translations/${translation.id}`,
          {
            root: supportApiBase,
            data: translationPayload,
          }
        );
      }
      if (!existingTranslation) {
        const translationResponse = await api(
          // @ts-ignore
          `POST /exercises/${exercise.id}/levels/${level.id}/translation`,
          {
            root: supportApiBase,
            data: translationPayload,
          }
        );
        const translationResponseJson = await translationResponse.json();
        const translationId = translationResponseJson.id;
        console.log("Translation created with ID:", translationId);
        translation.id = translationId; // Update the translation object with the new ID
      }
    }
  }

  // Clear IndexedDB chat histories for this exercise
  await clearExerciseHistories(exercise.id);

  return exercise.id;
};
